import instance from "@/services/api";

export const materialsOverspendAPI = {
  async getSmetaMaterialsOverspend(params) {
    return await instance()
      .get('/project/provider_requests/materials-overspend/', { params })
      .then(res => res?.data);
  },
}

